import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ContractsListItem from './ContractsListItem';
import ContractsDetails from './details/ContractsDetails';

import buttons from './ContractsButtons';
import events from './ContractsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('contracts'),
	routes: [
		{
			path: 'contracts/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'contracts'),
			element: (
				<DetailsPage
					key="contracts/add"
					module="contracts"
					tabs={ContractsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'contracts/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'contracts'),
			element: (
				<DetailsPage
					key="contracts/details"
					module="contracts"
					tabs={ContractsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'contracts/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'contracts'),
			element: (
				<ViewPage
					key="contracts/view"
					module="contracts"
					content={{ type: 'list', itemLayout: ContractsListItem, id: 'contractsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
